
<div class="audit-detail-dialog">
  <!-- Header -->
  <div class="dialog-header">
    <h2>Audit Log Details</h2>
    <button mat-icon-button (click)="dialogRef.close()" class="close-button" cdkFocusInitial>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <!-- Metadata Section -->
    <div class="log-metadata">
      <div class="metadata-row">
        <div class="metadata-item">
          <span class="label">Action</span>
          <span class="action-badge" [ngClass]="getActionClass(data.log.auditLogTypeName)">
            {{ data.log.auditLogTypeName }}
          </span>
        </div>
        <div class="metadata-item">
          <span class="label">Timestamp</span>
          <span class="value timestamp-value">{{ formatTimestamp(data.log.timeStamp) }}</span>
        </div>
      </div>

      <div class="metadata-row">
        <div class="metadata-item">
          <span class="label">Entity Type</span>
          <span class="value">{{ data.log.databaseEntityTypeName }}</span>
        </div>
        <div class="metadata-item">
          <span class="label">Entity ID</span>
          <span class="value">{{ data.log.entityId }}</span>
        </div>
      </div>

      @if (data.log.employeeId) {
      <div class="metadata-row">
        <div class="metadata-item">
          <span class="label">Employee ID</span>
          <span class="value">{{ data.log.employeeId }}</span>
        </div>
        @if (data.log.employee) {
        <div class="metadata-item">
          <span class="label">Employee</span>
          <span class="value">{{ data.log.employee.displayName }}</span>
        </div>
        }
      </div>
      }

      @if (data.log.message) {
      <div class="metadata-row">
        <div class="metadata-item full-width">
          <span class="label">Message</span>
          <pre class="value message-value">{{ data.log.message }}</pre>
        </div>
      </div>
      }

      <!-- Changes Section (inside metadata) -->
      @if (hasChanges()) {
      <div class="metadata-row">
        <div class="metadata-item full-width">
          <span class="label label-with-tooltip">
            Changes
            @if (getTimezoneTooltip()) {
            <mat-icon
              class="info-icon"
              [matTooltip]="getTimezoneTooltip()!"
              matTooltipPosition="right"
            >info</mat-icon>
            }
          </span>
          <div class="changes-box">
            @for (change of fieldChanges; track change.field) {
            <div class="change-item">
              <span class="field-name">"{{ formatFieldName(change.field) }}":</span>
              <div class="values-container">
                @if (change.newValue !== null) {
                <span class="new-value">{{ change.newValue }}</span>
                }
                @if (change.oldValue !== null && isValueChanged(change)) {
                <span class="old-value">{{ change.oldValue }}</span>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      } @else {
      <!-- No Changes State -->
      <div class="metadata-row">
        <div class="metadata-item full-width">
          <span class="label label-with-tooltip">
            Changes
            @if (getTimezoneTooltip()) {
            <mat-icon
              class="info-icon"
              [matTooltip]="getTimezoneTooltip()!"
              matTooltipPosition="right"
            >info</mat-icon>
            }
          </span>
          <div class="changes-box no-changes">
            <span>No field changes recorded for this audit log.</span>
          </div>
        </div>
      </div>
      }
    </div>
  </mat-dialog-content>
</div>
